/** Badging API guard: Chrome / Edge / Safari (installed PWA) expose setAppBadge, others do not. */
export function badgeSupported(
  nav: Navigator | undefined = typeof navigator === 'undefined' ? undefined : navigator,
): boolean {
  return !!nav && typeof nav.setAppBadge === 'function' && typeof nav.clearAppBadge === 'function';
}

/**
 * task.md §4.8: `navigator.setAppBadge` with the open-task count, cleared at 0 / logout. Never throws — an
 * unsupported or refused badge must not disturb the app.
 */
export async function setAppBadge(
  count: number,
  nav: Navigator | undefined = typeof navigator === 'undefined' ? undefined : navigator,
): Promise<boolean> {
  if (!nav || !badgeSupported(nav)) return false;
  try {
    if (count > 0) await nav.setAppBadge(Math.floor(count));
    else await nav.clearAppBadge();
    return true;
  } catch {
    return false;
  }
}
